// This composable is used to apply specific "Saving..."/"Saved!" subtitles to donut-accordion-radio
import { ref, computed } from 'vue';

const useAccordionSaveStatus = ({ options, timer = 1000 }) => {
  const subtitles = ref({});

  const startOptionSave = (optionValue) => {
    subtitles.value[optionValue] = 'Saving...';
  };

  const completeOptionSave = (optionValue) => {
    subtitles.value[optionValue] = 'Saved!';
    setTimeout(() => {
      subtitles.value[optionValue] = null;
    }, timer);
  };

  const optionsWithStatus = computed(() => options.value.map((option) => ({ ...option, subtitle: subtitles.value[option.value] })));

  return { optionsWithStatus, startOptionSave, completeOptionSave };
};

export default useAccordionSaveStatus;
